import { AppService } from '../services/app.service';
export const PipeConfig = Object.assign({
  numberFormat: '#,###.##',
  dateTimeFormat: 'DD-MM-YYYY HH:mm',
  dateFormat: 'DD-MM-YYYY',
  emptyInput: 'NA',
  currencyPrefix: '',
  currencyPostfix: '',
  currencyFormat: '##.### ',
  notAvailable: '-',
}, AppService.getAppSetting());
